import React from 'react';

/* eslint-disable max-len */
const Bell = props => {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.32892 0.818176C5.44226 0.818176 5.55559 0.818176 5.66892 0.818176C5.68668 0.826059 5.7037 0.836652 5.72219 0.841087C6.21078 0.957609 6.51649 1.26431 6.62569 1.75824C6.65755 1.90309 6.64345 2.05829 6.65098 2.21743C6.70717 2.23714 6.77186 2.25931 6.83606 2.28271C8.43149 2.86409 9.45951 4.36238 9.46729 6.12228C9.47046 6.83127 9.47021 7.54001 9.46632 8.249C9.46535 8.44928 9.52469 8.61384 9.66794 8.75524C9.89071 8.97548 10.106 9.20384 10.3234 9.42974C10.7468 9.86947 10.8626 10.4476 10.6369 10.9918C10.4117 11.535 9.92282 11.857 9.31554 11.8572C6.77088 11.858 4.22648 11.858 1.68183 11.856C1.56144 11.856 1.43814 11.8449 1.3214 11.8168C0.28194 11.5658 -0.103053 10.2757 0.625345 9.48394C0.848607 9.24128 1.07844 9.00405 1.31361 8.77322C1.47048 8.6195 1.53371 8.44238 1.53201 8.22387C1.52642 7.52326 1.52374 6.8224 1.53128 6.12179C1.54758 4.59567 2.19912 3.42281 3.4757 2.617C3.74712 2.44555 4.0538 2.33149 4.36 2.18343C4.35538 2.20166 4.35951 2.19378 4.35902 2.1859C4.35683 2.14082 4.35246 2.09598 4.35075 2.0509C4.33446 1.59417 4.51589 1.23697 4.89675 0.997024C5.02711 0.914991 5.18422 0.876561 5.32892 0.818176ZM5.20927 2.03809H5.79369C5.7988 1.8112 5.66649 1.66734 5.47874 1.68015C5.29852 1.69246 5.1847 1.84323 5.20902 2.03809H5.20927Z"
        fill="black"
      />
      <path
        d="M3.98975 12.7292H6.86476C6.90433 13.4449 6.24492 14.1462 5.50773 14.1803C4.69841 14.2177 4.00886 13.5648 3.98975 12.7292Z"
        fill="black"
      />
    </svg>
  );
};
/* eslint-enable max-len */

export default Bell;
